module.exports = __webpack_public_path__ + "img/indexSide-en-us.c652d415.png";